@if ($category()) {
  <div class="searchbar">
    <div class="parent-category">
      @if ($category()?.parent) {
        <a
          [routerLink]="['/location', $category()?.parent?.slug]"
          [queryParams]="{ search: $searchValue() }"
          title="Retourner à la catégorie {{ $category()?.parent?.label }}"
        >
          <fa-icon class="icon" [icon]="['fas', 'arrow-left']"></fa-icon>
        </a>
      }
    </div>

    <div class="searchbar-input">
      @if ($searchValue().length) {
        <fa-icon
          [icon]="['fas', 'close']"
          (click)="emptySearch()"
          title="Effacer la recherche"
        />
      }

      @if (!$searchValue()?.length) {
        <fa-icon [icon]="['fas', 'search']" title="Saisir votre recherche" />
      }
      <input
        [value]="$searchValue()"
        (keyup)="search($any($event.target).value)"
        placeholder="Rechercher dans la catégorie {{ $category()?.label }}..."
        type="text"
      />
    </div>

    <div class="searchbar-display">
      @if ($view() === VIEW.CELLS_LARGE) {
        <fa-stack
          tabindex="0"
          role="button"
          title="Vue catalogue - petit"
          (keydown.enter)="setCellsSmallView()"
          (click)="setCellsSmallView()"
        >
          <fa-icon
            [icon]="['fas', 'square']"
            stackItemSize="2x"
            [inverse]="true"
          ></fa-icon>
          <fa-icon
            class="icon"
            [icon]="['fas', 'table-cells']"
            stackItemSize="1x"
          ></fa-icon>
        </fa-stack>
      }

      @if ($view() === VIEW.CELLS_SMALL) {
        <fa-stack
          tabindex="0"
          role="button"
          title="Vue liste"
          (keydown.enter)="setListView()"
          (click)="setListView()"
        >
          <fa-icon
            [icon]="['fas', 'square']"
            stackItemSize="2x"
            [inverse]="true"
          ></fa-icon>
          <fa-icon
            class="icon"
            [icon]="['fas', 'th-list']"
            stackItemSize="1x"
          ></fa-icon>
        </fa-stack>
      }

      @if ($view() === VIEW.LIST) {
        <fa-stack
          tabindex="0"
          role="button"
          title="Vue Catalogue - Large"
          (keydown.enter)="setCellsLargeView()"
          (click)="setCellsLargeView()"
        >
          <fa-icon
            [icon]="['fas', 'square']"
            stackItemSize="2x"
            [inverse]="true"
          ></fa-icon>
          <fa-icon
            class="icon"
            [icon]="['fas', 'table-cells-large']"
            stackItemSize="1x"
          ></fa-icon>
        </fa-stack>
      }
    </div>
  </div>


  <div class="text">
    <div
      class="description"
      [innerHTML]="$category()?.description | safe: 'html'"
    ></div>
  </div>

  <div class="categories">
    @for (child of $category()?.children; track child.id) {
      <a
        class="category"
        [routerLink]="['/location/', child.slug]"
        queryParamsHandling="merge"
        onSameUrlNavigation="reload"
        title="{{ child.label + ' - ' + child.description }}"
      >
        <div class="category-label">{{ child.label }}</div>
      </a>
    }
  </div>


  <div class="show-packs">
    <label class="switch">
      <input id="show-packs" type="checkbox" [checked]="$showPacks()" (change)="toggleShowPacks()">
      <span class="slider"></span>
    </label>
    <label class="label" for="show-packs">Afficher les packs</label>
  </div>

  @if ($filteredProducts().length === 0) {
    <div class="no-results">
      <div class="no-results-message">
        <fa-icon [icon]="['fas', 'frown']"></fa-icon>
        Nous sommes désolé, aucun produit ne correspond actuellement à votre
        recherche dans
        <span>
          @for (item of $breadcrumbItems(); track $index) {
            <a
              [routerLink]="item | url"
              queryParamsHandling="merge"
              onSameUrlNavigation="reload"
              >{{ item.label }}</a
            >
            @if (!$last) {
              &nbsp;>&nbsp;
            }
          }
        </span>
      </div>

      <div class="no-results-actions">
        @if ($category()?.label !== "CATALOGUE") {
          <button (click)="goToTopCategory()">
            <fa-stack>
              <fa-icon [icon]="['fas', 'folder']" stackItemSize="2x"></fa-icon>
              <fa-icon
                class="icon"
                [icon]="['fas', 'arrow-left']"
                [inverse]="true"
                stackItemSize="1x"
              ></fa-icon>
            </fa-stack>
            Rechercher dans toutes les catégories
          </button>
        }
        @if ($searchValue().length) {
          <button (click)="emptySearch()">
            <fa-icon [icon]="['fas', 'text-slash']"></fa-icon>Effacer la
            recherche
          </button>
        }
      </div>
    </div>
  }

  @if ($filteredProducts().length > 0) {
    <div
      [class]="[
        'products',
        $view() === VIEW.CELLS_LARGE ? 'cells-large' : '',
        $view() === VIEW.CELLS_SMALL ? 'cells-small' : '',
        $view() === VIEW.LIST ? 'list' : '',
      ]"
      itemtype="https://schema.org/ItemList"
      itemscope
    >
      @for (
        product of $filteredProducts();
        track product.id;
        let index = $index
      ) {
        <a
          class="product"
          [routerLink]="['/location/', product.slug]"
          itemprop="itemListElement"
          itemscope
          itemtype="https://schema.org/ListItem"
        >
          <meta itemprop="position" content="{{ index }}" />
          <meta
            itemprop="url"
            content="{{
              environment.fullUrl +
                '/location/' +
                product.parent?.slug +
                '/' +
                product.slug
            }}"
          />

          <picture>
            <source
              type="image/webp"
              [srcset]="
                product.documents && product.documents[0]
                  ? environment.apiUrl + product.documents[0].src + '.webp'
                  : ('' | safeUrl)
              "
            />
            <source
              type="image/jpeg"
              [srcset]="
                product.documents && product.documents[0]
                  ? environment.apiUrl + product.documents[0].src + '.jpg'
                  : ('' | safeUrl)
              "
            />
            <source
              type="image/png"
              [srcset]="
                product.documents && product.documents[0]
                  ? environment.apiUrl + product.documents[0].src + '.png'
                  : ('' | safeUrl)
              "
            />
            <img
              [attr.alt]="product.label + '  &#13;&#13;' + product.description"
              loading="lazy"
            />
          </picture>

          <div class="product-infos">
            <div class="product-label">
              <div>
                {{ product.label }}
              </div>
            </div>
            <div class="product-description">
              <div [innerHtml]="product.description | safe: 'html'"></div>
            </div>
          </div>

          <div class="product-price">
            @if (!product.variants.length) {
              @if (+product.price !== 0) {
                <span>à partir de {{ product.price * 1.2 | price }} TTC</span>
              }
              @if (+product.price === 0) {
                <span>sur demande</span>
              }
            }
            @if (product.variants.length) {
              <span>selon variante</span>
            }
          </div>
        </a>
      }
    </div>
  }
}
